// extracted by mini-css-extract-plugin
module.exports = {"ShopBasicSettingsSection":"shop-basic-settings-section__ShopBasicSettingsSection___19eD-","FormContainer":"shop-basic-settings-section__FormContainer___3n6HX"};